import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "input", "icon" ]

  connect() {
    this.updateIcon()
  }

  toggle() {
    this.updateIcon()
  }

  updateIcon() {
    const wrapper = this.iconTarget.parentElement
    if (this.inputTarget.checked) {
      wrapper.classList.remove('svg-icon')
      wrapper.classList.add('svg-selected')
    } else {
      wrapper.classList.remove('svg-selected')
      wrapper.classList.add('svg-icon')
    }
  }
}
